// filepath: /home/yosef-benny-widyokarsono/kominfo/emas/app/javascript/controllers/trix_validation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trixEditor", "form"]

  connect() {
    this.formTarget.addEventListener('submit', this.validateTrix.bind(this))
    console.log('trixEditor connected ');
    console.log('formTarget: ', this.formTarget); // Add this
    console.log('trixEditorTarget: ', this.trixEditorTarget); // Add this
  }

  validateTrix(event) {
    const editorContent = this.trixEditorTarget.editor.getDocument().toString().trim()
    console.log('editorContent: ', editorContent);
    console.log('validationMessage: ', this.trixEditorTarget.dataset.validationMessage); // Add this

    if (editorContent === '') {
      event.preventDefault()
      // Get the validation message from the data attribute
      const validationMessage = this.trixEditorTarget.dataset.validationMessage
      console.log('Using validation message:', validationMessage);

      // Display the custom validation message
      alert(validationMessage)
      this.trixEditorTarget.focus()
    }
  }
}